/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import ImageSeries from './ImageSeries/index'
import NewImageSeriesAction from './NewImageSeriesAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images"
  
}) {
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 patientTab="images"
/>
<div
  data-testid="Images.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z2tKXei': dtColorsWhite,'--bbc-2-Z2tKXei': dtColorsNeutral300,'--pl-3-Z2tKXei': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z2tKXei': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-5-Z2tKXei': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-6-Z2tKXei': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
<NewImageSeriesAction
  viewPath={`${viewPath}/NewImageSeriesAction`}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}